import React from 'react';
import sanitize from '../../utils/sanitize';

const md = require('markdown-it')({ html: true });

function Img({ image, text, width, style }) {
  return style === 'inline' ? (
    <img
      src={image}
      alt={text}
      className={
        width === '25%'
          ? 'lozad autow-full md:w-1/4 basis-full md:basis-1/4'
          : width === '33%'
          ? 'lozad auto w-full md:w-1/3 basis-full md:basis-1/3'
          : width === '50%'
          ? 'lozad auto w-full md:w-1/2 basis-full md:basis-1/2'
          : width === '66%'
          ? 'lozad auto w-full md:w-2/3 basis-full md:basis-2/3'
          : width === '75%'
          ? 'lozad auto w-full md:w-3/4 basis-full md:basis-3/4'
          : 'lozad auto'
      }
      style={{
        margin: style === 'inline' ? '1.5rem 0' : '0',
      }}
    />
  ) : (
    <div
      className={
        width === '25%'
          ? 'h-96 lg:h-auto lg:w-1/4 lg:basis-1/4 background-salmon lozad order-2 lg:order-none'
          : width === '33%'
          ? 'h-96 lg:h-auto lg:w-1/3 lg:basis-1/3 background-salmon lozad order-2 lg:order-none'
          : width === '50%'
          ? 'h-96 lg:h-auto lg:w-1/2 lg:basis-1/2 background-salmon lozad order-2 lg:order-none'
          : width === '66%'
          ? 'h-96 lg:h-auto lg:w-2/3 lg:basis-2/3 background-salmon lozad order-2 lg:order-none'
          : width === '75%'
          ? 'h-96 lg:h-auto lg:w-3/4 lg:basis-3/4 background-salmon lozad order-2 lg:order-none'
          : 'h-96 lg:h-auto lg:w-1/2 lg:basis-1/2 background-salmon lozad order-2 lg:order-none'
      }
      data-background-image={image}
      style={{
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      }}
    />
  );
}

function InlineImageText({
  image,
  text = '',
  width = '33%',
  style = 'inline',
  bgColor = 'transparent',
  layout = 'left',
}) {
  if (!image) return null;

  return (
    <div
      className={
        style === 'full-width'
          ? 'flex flex-col lg:flex-row lg:min-h-[680px] lg:max-h-[1024px] lg:gap-6'
          : 'block lg:flex lg:flex-row items-center gap-6'
      }
      style={{
        backgroundColor: bgColor,
        marginBottom: style === 'inline' ? '2rem' : '0',
        justifyContent: style === 'inline' ? 'justify-between' : 'center',
      }}
    >
      {layout === 'left' ? (
        <Img image={image} text={text} width={width} style={style} />
      ) : null}
      <div
        className={
          width === '25%'
            ? 'w-full lg:w-3/4 basis-full lg:basis-3/4 order-1 lg:order-none flex items-center'
            : width === '33%'
            ? 'w-full lg:w-2/3 basis-full lg:basis-2/3 order-1 lg:order-none flex items-center'
            : width === '50%'
            ? 'w-full lg:w-1/2 basis-full lg:basis-1/2 order-1 lg:order-none flex items-center'
            : width === '66%'
            ? 'w-full lg:w-1/3 basis-full lg:basis-1/3 order-1 lg:order-none flex items-center'
            : width === '75%'
            ? 'w-full lg:w-1/4 basis-full lg:basis-1/4 order-1 lg:order-none flex items-center'
            : 'w-full'
        }
        style={{
          padding: style === 'inline' ? '0' : '70px 20px 50px',
        }}
      >
        <div
          className={
            style === 'full-width'
              ? 'no-child-p-mb lg:w-[500px] max-w-full'
              : 'no-child-p-mb'
          }
          dangerouslySetInnerHTML={{ __html: sanitize(md.render(text)) }}
        />
      </div>
      {layout === 'right' ? (
        <Img image={image} text={text} width={width} style={style} />
      ) : null}
    </div>
  );
}
export default InlineImageText;
